/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StreakFreezePurchaseResponse
 */
export interface StreakFreezePurchaseResponse {
    /**
     * Updated number of freezes remaining after purchase
     * @type {number}
     * @memberof StreakFreezePurchaseResponse
     */
    freezesRemaining: number;
    /**
     * Amount of Fuel deducted for this purchase
     * @type {number}
     * @memberof StreakFreezePurchaseResponse
     */
    fuelDeducted: number;
}

/**
 * Check if a given object implements the StreakFreezePurchaseResponse interface.
 */
export function instanceOfStreakFreezePurchaseResponse(value: object): value is StreakFreezePurchaseResponse {
    if (!('freezesRemaining' in value) || value['freezesRemaining'] === undefined) return false;
    if (!('fuelDeducted' in value) || value['fuelDeducted'] === undefined) return false;
    return true;
}

export function StreakFreezePurchaseResponseFromJSON(json: any): StreakFreezePurchaseResponse {
    return StreakFreezePurchaseResponseFromJSONTyped(json, false);
}

export function StreakFreezePurchaseResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StreakFreezePurchaseResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'freezesRemaining': json['freezesRemaining'],
        'fuelDeducted': json['fuelDeducted'],
    };
}

export function StreakFreezePurchaseResponseToJSON(json: any): StreakFreezePurchaseResponse {
    return StreakFreezePurchaseResponseToJSONTyped(json, false);
}

export function StreakFreezePurchaseResponseToJSONTyped(value?: StreakFreezePurchaseResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'freezesRemaining': value['freezesRemaining'],
        'fuelDeducted': value['fuelDeducted'],
    };
}

